import { useFormikContext } from 'formik';
import { useEffect } from 'react';

type ListenToFormikValuesProps = {
  callBackFunc: (values: unknown) => void;
};

export const ListenToFormikValues = ({
  callBackFunc,
}: ListenToFormikValuesProps): null => {
  const { values } = useFormikContext();

  useEffect(() => {
    if (values) {
      callBackFunc(values);
    }
  }, [values]);

  return null;
};
